<ng-template #callingModal>
  <div mat-dialog-content class="calling-content">
    <div class="flex justify-between align-middle">
      <i class="fa-solid fa-signal f-20px text-success cursor-pointer" title="Good"></i>
      <i class="fa-solid fa-minus f-20px text-danger cursor-pointer" title="Minimize" (click)="dialog.closeAll()"></i>
    </div>
    <div class="subheading-2 text-center">
      <i class="fa-solid fa-a f-40px caller-name"></i>
      <h2 class="f-30px mt-35px text-italic color-blue">Abhishek</h2>
      <h2 class="mt-35px text-italic text-success">
        <span>
          <i class="fa-solid fa-circle mr-10px text-danger f-20px fa-beat-fade" title="Recording under progress"></i>
        </span>
        <span class="f-24px">10:05</span>
      </h2>
      <div class="p-6 flex justify-center lg:min-w-[100%] lg:max-w-[100%] text-center my-auto mt-35px shadow-light-up">
        <!--<i class="fa-solid fa-f f-30px text-info mr-100px"></i>
        <span class="color-white f-24px mr-100px">10:05</span>-->
        <i class="fa-solid fa-pause f-30px text-info mr-30px cursor-pointer"></i>
        <i class="fa-solid fa-play f-30px text-info mr-30px cursor-pointer"></i>
        <i class="fa-solid fa-microphone-slash f-30px text-info mr-30px cursor-pointer"></i>
        <i class="fa-solid fa-microphone f-30px text-info mr-30px cursor-pointer"></i>
        <i class="fa-solid fa-phone f-30px text-danger cursor-pointer"></i>
      </div>
    </div>
  </div>
</ng-template>
<div class="card calling-card" *ngIf="!hideCallingIcon">
  <div class="card-body">
    <i class="fa-solid fa-headphones fa-beat-fade f-30px color-white cursor-pointer" title="Calling Info"
       (click)="openCallingModal()"></i>
  </div>
</div>
